<div style="display: flex;">
    <p-dialog
        [(visible)]="showAbout"
        header="About"
        [modal]="true"
    >
        <div class="grid border-round" style="min-width: 46rem;">
            <!--ABOUT-->
            <div class="col col-12">
                <div class="surface-card border-round text-left shadow-2 p-3" style="height: 100%">
                    <!-- <span class="text-xl text-left font-medium text-90">About</span> -->
                    <div class="p-4">
                        <div class="p-2 mb-4 flex">
                            <span class="p-float-label w-full">
                                <input class="w-full" type="text" id="admincount" pInputText [(ngModel)]="eFAACTVersion" readonly>
                                <label for="admincount">eFAACT Version</label>
                            </span>
                        </div>
                        <div class="p-2 mb-4 flex">
                            <span class="p-float-label w-full">
                                <input class="w-full" type="text" id="admincount" pInputText [(ngModel)]="eFAACTApiVersion" readonly>
                                <label for="admincount">eFAACT API Version</label>
                            </span>
                        </div>
                        <div class="p-2 mb-4 flex">
                            <span class="p-float-label w-full">
                                <input class="w-full" type="text" id="admincount" pInputText [(ngModel)]="softwareLicenseAgreementLink" readonly>
                                <label for="admincount">License Agreement</label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-dialog>

</div>

<div class="topbar clearfix" style="z-index: 2000">
    <div class="topbar-left">
        <div>
            <div class="company-title float-start">
                <a uiSref="main">
                    <h2>{{ app.title }}</h2>
                    <i class="fa fa-fw fa-home"></i>
                </a>
            </div>
        </div>
    </div>
    <div class="topbar-right">
        <div style="margin-left: 3rem" class="float-start">
            <a
                *ngIf="app.hasCompanyURL === true"
                href="#"
                (click)="app.openUserManual()"
            >
                <ef-member></ef-member>
            </a>
            <div *ngIf="app.hasCompanyURL !== true">
                <ef-member></ef-member>
            </div>
        </div>
        <a
            id="menu-button"
            href="#"
            (click)="app.onMenuButtonClick($event)"
            [ngClass]="{ 'menu-button-rotate': !app.rotateMenuButton }"
        >
            <i color="primary" class="fa fa-angle-left"></i>
        </a>
        <a
            id="topbar-menu-button"
            href="#"
            (click)="app.onTopbarMenuButtonClick($event)"
        >
            <i class="fa fa-bars"></i>
        </a>
        <ul
            class="topbar-items fadeInDown"
            [ngClass]="{ 'topbar-items-visible': app.topbarMenuActive }"
        >
            <li role="menuitem" *ngIf="userInfo?.EmployeeListID">
                <a (click)="app.onSignout()" style="cursor: pointer">
                    <i class="topbar-icon pi pi-sign-out"></i>
                    <span class="topbar-item-name">Logout</span>
                </a>
            </li>
            <li
                #profile
                *ngIf="
                    (app.profileMode === 'top' || app.isHorizontal()) &&
                    userInfo?.EmployeeListID
                "
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === profile,
                    'profile-item': true
                }"
            >
                <a
                    [title]="userInfo.EmployeeName"
                    (click)="app.onTopbarItemClick($event, profile)"
                >
                    <i class="topbar-icon pi pi-user"></i>
                    <span class="topbar-item-name" style="font-size: 15px">
                        {{ userInfo.EmployeeName }}
                    </span>
                </a>
                <ul class="layout-menu fadeInDown" *ngIf="roles">
                    <li
                        *ngFor="let role of roles"
                        [ngClass]="{
                            selected:
                                role.RoleGroupID === userInfo.DefaultRoleGroupID
                        }"
                    >
                        <a
                            style="cursor: pointer"
                            (click)="roleChosen(role.RoleGroupID)"
                            [title]="role.GroupName"
                        >
                            <i class="pi pi-users"></i>
                            <span>{{ role.GroupName }}</span>
                        </a>
                    </li>
                    <li
                        class="ui-menu-separator"
                        style="color: black; background-color: black"
                    ></li>
                    <li *featureFlag="'advisorSwitch'">
                        <span *ngIf="isAdmin(roles)">
                            <a
                                style="cursor: pointer"
                                (click)="switchCompany()"
                            >
                                <i class="pi pi-id-card"></i>
                                <span>Switch Company</span>
                            </a>
                        </span>
                    </li>
                </ul>
            </li>
            <li
                #profile
                *ngIf="!userInfo?.EmployeeListID"
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === profile
                }"
            >
                <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Login"
                    href="#"
                    (click)="app.onSignout()"
                >
                    <i class="topbar-icon pi pi-sign-in"></i>
                    <span class="topbar-item-name"> Login </span>
                </a>
            </li>
            <!-- <li
                #settings
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === settings
                }"
            >
                <a href="#" (click)="app.onTopbarItemClick($event, settings)">
                    <i class="topbar-icon fa fa-fw fa-cog"></i>
                    <span class="topbar-item-name">Settings</span>
                </a>
                <ul class="layout-menu fadeInDown" style="width: 15em">
                    <li *ngFor="let process of mainProcess$ | async">
                        <a (click)="app.onProcessClick(process)">
                            <span>{{ process.ProcessTitle }}</span>
                        </a>
                    </li>
                </ul>
            </li> -->
            <li
                #helpdesk
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === helpdesk
                }"
            >
                <a
                    (click)="app.onTopbarItemClick($event, helpdesk)"
                    title="Help"
                >
                    <i class="topbar-icon far fa-question-circle"></i>
                    <span class="topbar-item-name">Help</span>
                </a>
                <ul class="layout-menu fadeInDown" style="width: 15em">
                    <li role="menuitem">
                        <a
                            data-toggle="tooltip"
                            data-placement="top"
                            (click)="openHelpDesk()"
                            href="#"
                        >
                            <span>eFAACT Help Desk</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a uiSref="helpdesk">
                            <span>eFAACT Guide</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a
                            uiSref="usermanual"
                            (click)="openUserManual()"
                            href="#"
                        >
                            <span>eFAACT User Manual</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a href=" https://efaactcentral.com/releasenotes/efaactreleasenotes.htm" target="_blank">Release Notes</a>
                        <!-- <a uiSref="about">
                            <span>About</span>
                        </a> -->
                    </li>
                    <li role="menuitem">
                        <button pButton style="margin-left: .7rem; margin-bottom: .5rem;" type="button" label="About" class="p-button-link" (click)="openAbout()"></button>
                    </li>
                </ul>
            </li>
            <!-- <li
                #messages
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === messages
                }"
            >
                <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Messages"
                    href="#"
                    (click)="app.onTopbarItemClick($event, messages)"
                >
                    <i class="topbar-icon animated swing fa fa-fw fa-bell"></i>

                    <span class="topbar-item-name">Messages</span>
                </a>
            </li> -->
            <!-- <span class="topbar-badge animated rubberBand"></span> -->
            <!-- <li
                #calendar
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === calendar
                }"
            >
                <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Calendar"
                    href="#"
                    (click)="app.onTopbarCompanyCalendarClick($event)"
                >
                    <i
                        class="topbar-icon animated swing fas fa-calendar-alt"
                    ></i>
                    <span class="topbar-item-name">Calendar</span>
                </a>
            </li> -->
            <li
                #errorsSidenav
                id="efErrorsSideNav"
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === errorsSidenav
                }"
            >
                <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Errors"
                    href="#"
                    (click)="
                        app.onTopbarItemClick(
                            $event,
                            this.app.errorCount ? errorsSidenav : null,
                            'errors'
                        )
                    "
                >
                    <i class="topbar-icon fas fa-exclamation-triangle"></i>
                    <span
                        class="topbar-badge animated rubberBand"
                        [hidden]="!this.app.errorCount"
                        >{{ this.app.errorCount }}</span
                    >
                    <span class="topbar-item-name">Errors</span>
                </a>

                <ul class="layout-menu fadeInDown">
                    <ef-errors-sidenav></ef-errors-sidenav>
                </ul>
            </li>
            <!-- <li
                class="ui-menu-separator"
                style="color: white; background-color: white"
            ></li> -->
            <li
                #reportsSideNav
                id="efreportsSideNav"
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === reportsSideNav
                }"
            >
                <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Reports"
                    href="#"
                    (click)="app.onReportButtonClick($event)"
                >
                    <i class="topbar-icon far fa-file-alt"></i>
                    <span class="topbar-item-name">Reports</span>
                </a>
            </li>
            <!-- <li
                #dashboard
                id="dashboard"
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === dashboard
                }"
            >
                <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Dashboard"
                    href="#"
                    (click)="app.onDashboardButtonClick($event)"
                >
                    <i class="topbar-icon pi pi-th-large"></i>
                    <span class="topbar-item-name">Dashboard</span>
                </a>
            </li> -->
            <li
                #search
                id="search"
                [ngClass]="{
                    'active-top-menu': app.activeTopbarItem === search
                }"
                style="margin-right: 2em"
            >
                <div
                    style="
                        background-color: white;
                        border-radius: 3px;
                        padding-left: 2.4em;
                    "
                    *ngIf="this.processes.length > 0"
                >
                    <div style="display: flex; flex-direction: row">
                        <p-autoComplete
                            id="searchbar"
                            showClear="true"
                            [ngStyle]="{
                                border: '0',
                                'z-index': '9999',
                                'margin-left': '-2.3em',
                                'margin-right': '-2.2em'
                            }"
                            placeholder="Search..."
                            [forceSelection]="true"
                            [(ngModel)]="selectedProcess"
                            [suggestions]="this.processTitles"
                            (completeMethod)="filterProcessFromSearch($event)"
                            (onSelect)="gotoProcessFromSearch($event)"
                            [minLength]="1"
                        >
                        </p-autoComplete>

                        <span
                            class="pi pi-search"
                            style="
                                padding-left: 0.5em;
                                padding-right: 0.5em;
                                font-size: 16px;
                                margin-top: 0.4em;
                                z-index: 9998;
                            "
                        ></span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>
